import { render, staticRenderFns } from "./breadcrumbItem.vue?vue&type=template&id=0333ab85"
import script from "./breadcrumbItem.vue?vue&type=script&lang=js"
export * from "./breadcrumbItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports